import * as _ from "lodash-es";

export default {
  namespaced: true,
  state: {
    events: {},
    eventKindOptions: {},
  },
  mutations: {
    setEvents(state, events) {
      state.events = _.keyBy(events, "id");
    },
    updateEvent(state, event) {
      state.events = { ...state.events, [event.id]: event };
    },
    setEventKindOptions(state, options) {
      state.eventKindOptions = _.keyBy(options, "id");
    },
  },
  getters: {
    eventsListDesc: (state) =>
      _.orderBy(Object.values(state.events), ["start_datetime"], ["desc"]),
    enabledEventKindOptionsList: (state) =>
      _.sortBy(state.eventKindOptions, ["created_at"]).filter(
        (option) => option.is_enabled,
      ),
    eventKindOptionsChoices: (state, getters) =>
      getters.enabledEventKindOptionsList.map((option) => ({
        value: option.id,
        text: option.label,
      })),
  },
};
